import React, { useContext, useState, useEffect, createContext, Suspense } from "react";
// import { loadUsetifulScript, setUsetifulTags } from "usetiful-sdk"; // 🔹 Usetiful DESATIVADO
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Loading from "react-loading";
import DeliveryLoading from "./components/DeliveryLoading";
import RouteTracker from "./utils/RouteTracker"; // Importar o RouteTracker

import useCheckLicense from "./hooks/useCheckLicense"; // Importar o hook

import LeftMenu from "./components/LeftMenu"
import LoginPage from "./pages/Login";
import HomePage from "./pages/Home";
import Pdv from "./pages/Pdv";
import AddCategoria from "./pages/ListCategoria/addCategoria";
import AddItem from "./pages/ListItem/addItem";
import ListEntregadores from "./pages/ListEntregadores";
import ListCategoria from "./pages/ListCategoria";
import ListItem from "./pages/ListItem";
import ListAdicional from "./pages/ListAdicional";
import GestaoEstoque from "./pages/GestaoEstoque";
import RecuperarSenha from "./pages/RecuperarSenha";
import RedefinirSenha from "./pages/RedefinirSenha";
import Cardapio from "./pages/Cardapio";
import CardapioSalao from "./pages/CardapioSalao";
import DetalheProduto from "./pages/Cardapio/detalheProduto";
import DetalheProdutoSalao from "./pages/CardapioSalao/detalheProduto";
import Carrinho from "./pages/Cardapio/carrinho";
import MeusPedidos from "./pages/Cardapio/MeusPedidos";
import AddRaioEntrega from "./pages/Mapa/addRaioEntrega";
import EnderecoEstabelecimento from "./pages/Endereco/enderecoEstabelecimento";
import WhatsSync from "./pages/Whatsapp/sync";
import WhatsApp from "./pages/Whatsapp";
import Planos from "./pages/MinhaConta/planos";

import IntegracaoCardapio from "./pages/AddEmpresaCliente/integracao";
import Endereco from "./pages/AddEmpresaCliente/endereco";
import PlanosAdmin from "./pages/PlanosAdmin/addPlanos";
import ListPlanosAdmin from "./pages/PlanosAdmin/listPlansAdmin";
import EditPlano from "./pages/PlanosAdmin/editPlano";
import FinalizarPedido from "./pages/Cardapio/finalizarPedido";
import AddEndereco from "./pages/Cardapio/addEndereco";
import ConfigPrinter from "./pages/Impressora";
import SupportPrivacy from "./pages/SupportPrivacy";
import HorarioFuncionamento from "./pages/HorarioFuncionamento";
import MeusPedidosCfg from "./pages/MeusPedidosConfig";
import RoboCfg from "./pages/roboConfig";
import InformacoesLoja from "./pages/InformacoesLoja";

import InfoLoja from "./pages/Cardapio/infoLoja";
import InfoLojaSalao from "./pages/CardapioSalao/infoLoja";
import RelatorioGeral from "./pages/Relatorios/geral";
import Desempenho from "./pages/Relatorios/desempenho";
import Abandono from "./pages/Relatorios/abandono";
import RelatorioProdutos from "./pages/Relatorios/produtos";
import RelatorioGeografico from "./pages/Relatorios/geografico";
import RelatorioClientes from "./pages/Relatorios/clientes";
import RelatorioPagamentos from "./pages/Relatorios/pagamentos";
import RelatorioHorarios from "./pages/Relatorios/horarios";
import RelatorioDescontos from "./pages/Relatorios/descontos";
import RelatorioEstoque from "./pages/Relatorios/estoque";
import RelatorioEntregadores from "./pages/Relatorios/entregadores";
import RelatorioGorjetas from "./pages/Relatorios/gorjetas";

//import TesteSocketIO from "./pages/Whatsapp/socketIOcomponent"; // Teste Socket IO

import { AuthProvider, AuthContext } from "./contexts/auth";
import { EmpresaProvider } from "./contexts/empresaContext";
import { isFeatureEnabled } from "./hooks/useFeatureFlag";

import ImportaCardapio from "./pages/ImportaCardapio";
import TeamManagement from "./pages/Team";
import FormasPagamento from "./pages/FormasPagamento";
import FormasTiposEntrega from "./pages/FormasTiposEntrega";
import ListEmpresas from "./pages/ListEmpresas";
import AdminSolicitacoesCardapio from "./pages/AdminSolicitacoesCardapio";
import SupportInbox from "./pages/SupportInbox";
import SupportChat from "./components/SupportChat";
import SupportObservation from "./components/SupportChat/SupportObservation";
import Caixa from "./pages/Caixa";
import CaixaHistory from "./pages/Caixa/CaixaHistory";
import CaixaById from "./pages/Caixa/CaixaById";
import Mesas from "./pages/Mesas";

const AddEmpresa = React.lazy(() => import("./pages/AddEmpresaCliente"));
//const Caixa = React.lazy(() => import("./pages/Caixa"));
//const CaixaHistory = React.lazy(() => import("./pages/Caixa/CaixaHistory"));
//const CaixaById = React.lazy(() => import("./pages/Caixa/CaixaById"));
//const Mesas = React.lazy(() => import("./pages/Mesas"));

const LandPage = React.lazy(() => import("./pages/LandPage"));

const AddCredencial = React.lazy(() =>
  import("./pages/AddEmpresaCliente/credenciais")
);

const ConfiguracaoInicial = React.lazy(() =>
  import("./pages/ConfiguracaoInicial")
);

const ConfiguracaoTuna = React.lazy(() =>
  import("./pages/ConfiguracaoTuna")
);

// Criando o contexto Sidebar
export const SidebarContext = createContext({
  sidebar: true,
  setSidebar: () => { }, // Valor inicial como uma função vazia
});
export const SidebarProvider = ({ children }) => {
  const [sidebar, setSidebar] = useState(window.innerWidth >= 768); // 🔹 Fecha apenas em mobile (<768px)

  return (
    <SidebarContext.Provider value={{ sidebar, setSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
};

// Componente de Layout que inclui o LeftMenu
const Layout = ({ children }) => {
  const { sidebar, setSidebar } = useContext(SidebarContext);

  return (
    <>
      <LeftMenu setSidebar={setSidebar} sidebar={sidebar} />
      <div style={{ 
        //marginTop: '80px', // Compensa a altura do navbar fixo
        //minHeight: 'calc(100vh - 80px)', // Garante altura mínima
        //backgroundColor: 'rgb(247,247,247)' // Mantém consistência de cor
      }}>
        {children}
      </div>
    </>
  );
};

const AppRoutes = () => {

  const PrivateRoute = ({ children }) => {
    useCheckLicense();
    const { authenticated, loading, hasLicense, redirectToPlanos, user } = useContext(AuthContext);

    // Remove o loading HTML do index.html quando auth terminar de carregar
    useEffect(() => {
      if (!loading && window.__removeInitialLoading) {
        window.__removeInitialLoading();
      }
    }, [loading]);

    //const { sidebar, setSidebar } = useContext(SidebarContext); //TESTANDO CONST NO AppROUTES
    // 🔹 Usetiful DESATIVADO
    // useEffect(() => {
    //   if (authenticated && user) {
    //     process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🔹 Carregando Usetiful...");
    //     loadUsetifulScript("fd74333f30ec05ce31b5da50cc1be18f");
    //     try {
    //       setUsetifulTags({
    //         userId: user.id,
    //         firstName: user.name,
    //         lastName: user.role,
    //       });
    //       process.env.REACT_APP_ISDEVELOP === 'true' && console.log("✅ Usetiful configurado com sucesso!");
    //     } catch (error) {
    //       process.env.REACT_APP_ISDEVELOP === 'true' && console.error("❌ Erro ao definir os dados do Usetiful:", error);
    //     }
    //   }
    // }, [authenticated, user]);

    if (loading) {
      // Loading HTML do index.html ainda está visível, não precisa renderizar nada
      return null;
    }

    if (!authenticated) {
      return <Navigate to="/login" />;
    }

    if (
      !hasLicense &&
      hasLicense !== null &&
      window.location.pathname !== "/planos" &&
      redirectToPlanos
    ) {
      return <Navigate to="/planos" />;
    }

    /*return (
      <>
        {children}
      </>
    );*/
    return <Layout>{children}</Layout>; // Envolve as páginas no Layout para incluir o LeftMenu
  };

  return (
    <Router>
      <AuthProvider>
        <EmpresaProvider>
          <SidebarProvider>
            <RouteTracker />
            <SupportChat />
            <SupportObservation />
            <Routes>
            <Route path="/suporte" element={<PrivateRoute><SupportInbox /></PrivateRoute>} />
            <Route
              exact
              path="/landpage"
              element={
                <Suspense fallback={<Loading />}>
                  <LandPage />
                </Suspense>
              }
            />
            <Route
              exact
              path="/informacoes"
              element={
                <Suspense fallback={<Loading />}>
                  <AddEmpresa />
                </Suspense>
              }
            />
            <Route
              exact
              path="/credenciais"
              element={
                <Suspense fallback={<Loading />}>
                  <AddCredencial />
                </Suspense>
              }
            />
            <Route
              exact
              path="/configuracao-inicial"
              element={
                <Suspense fallback={<Loading />}>
                  <ConfiguracaoInicial />
                </Suspense>
              }
            />
            <Route path="/configuracao-Inicial" element={<Navigate to="/configuracao-inicial" replace />} />
            <Route exact path="/integracao" element={<IntegracaoCardapio />} />
            <Route exact path="/endereco" element={<Endereco />} />
            <Route exact path="/login" element={<LoginPage />} />
            <Route
              exact
              path="/"
              element={
                <PrivateRoute>
                  <HomePage />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/pdv"
              element={
                <PrivateRoute>
                  <Pdv />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/cadastro-categoria"
              element={
                <PrivateRoute>
                  <AddCategoria />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/cadastro-item"
              element={
                <PrivateRoute>
                  <AddItem />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/list-entregadores"
              element={
                <PrivateRoute>
                  <ListEntregadores />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/list-empresas"
              element={
                <PrivateRoute>
                  <ListEmpresas />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/admin-solicitacoes-cardapio"
              element={
                <PrivateRoute>
                  <AdminSolicitacoesCardapio />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/mesas-garcons"
              element={
                <PrivateRoute>
                  <TeamManagement fixedRoleFilter="garcom" />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/team"
              element={
                <PrivateRoute>
                  <TeamManagement />
                </PrivateRoute>
              }
            />            
            <Route
              exact
              path="/list-categoria"
              element={
                <PrivateRoute>
                  <ListCategoria />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/gestao-estoque"
              element={
                <PrivateRoute>
                  <GestaoEstoque />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/list-item"
              element={
                <PrivateRoute>
                  <ListItem />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/list-adicional"
              element={
                <PrivateRoute>
                  <ListAdicional />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/endereco-estabelecimento"
              element={
                <PrivateRoute>
                  <EnderecoEstabelecimento />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/raio-entrega"
              element={
                <PrivateRoute>
                  <AddRaioEntrega />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/whatsapp-sync"
              element={
                <PrivateRoute>
                  <WhatsSync />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/whatsapp"
              element={
                <PrivateRoute>
                  <WhatsApp />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/impressora"
              element={
                <PrivateRoute>
                  <ConfigPrinter />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/privacidade-suporte"
              element={
                <PrivateRoute>
                  <SupportPrivacy />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/horario-funcionamento"
              element={
                <PrivateRoute>
                  <HorarioFuncionamento />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/formas-pagamento"
              element={
                <PrivateRoute>
                  <FormasPagamento />
                </PrivateRoute>
              }
            />
            {isFeatureEnabled('tunaPayments') && (
            <Route
              exact
              path="/configuracao-tuna"
              element={
                <PrivateRoute>
                  <Suspense fallback={<Loading />}>
                    <ConfiguracaoTuna />
                  </Suspense>
                </PrivateRoute>
              }
            />
            )}
            <Route
              exact
              path="/entrega-retirada"
              element={
                <PrivateRoute>
                  <FormasTiposEntrega />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/meus-pedidos-configuracao"
              element={
                <PrivateRoute>
                  <MeusPedidosCfg />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/robo-configuracao"
              element={
                <PrivateRoute>
                  <RoboCfg />
                </PrivateRoute>
              }
            />

            <Route
              exact
              path="/informacoes-loja"
              element={
                <PrivateRoute>
                  <InformacoesLoja />
                </PrivateRoute>
              }
            />

            <Route
              exact
              path="/planos"
              element={
                <PrivateRoute>
                  <Planos />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/planos-admin"
              element={
                <PrivateRoute>
                  <PlanosAdmin />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/list-plans-admin"
              element={
                <PrivateRoute>
                  <ListPlanosAdmin />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/edit-plan-admin/:id"
              element={
                <PrivateRoute>
                  <EditPlano />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/relatorio-geral"
              element={
                <PrivateRoute>
                  <RelatorioGeral />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/relatorio-entregadores"
              element={
                <PrivateRoute>
                  <RelatorioEntregadores />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/relatorio-gorjetas"
              element={
                <PrivateRoute>
                  <RelatorioGorjetas />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/desempenho"
              element={
                <PrivateRoute>
                  <Desempenho />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/carrinhos-abandonados"
              element={
                <PrivateRoute>
                  <Abandono />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/relatorio-produtos"
              element={
                <PrivateRoute>
                  <RelatorioProdutos />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/relatorio-geografico"
              element={
                <PrivateRoute>
                  <RelatorioGeografico />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/relatorio-clientes"
              element={
                <PrivateRoute>
                  <RelatorioClientes />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/relatorio-pagamentos"
              element={
                <PrivateRoute>
                  <RelatorioPagamentos />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/relatorio-horarios"
              element={
                <PrivateRoute>
                  <RelatorioHorarios />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/relatorio-descontos"
              element={
                <PrivateRoute>
                  <RelatorioDescontos />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/relatorio-estoque"
              element={
                <PrivateRoute>
                  <RelatorioEstoque />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="pedidos-mesas"
              element={
                <PrivateRoute>
                  <Suspense fallback={<Loading />}>
                    <Mesas />
                  </Suspense>

                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/caixa"
              element={
                <PrivateRoute>
                  <Suspense fallback={<Loading />}>
                    <Caixa />
                  </Suspense>
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/caixa/historico"
              element={
                <PrivateRoute>
                  <Suspense fallback={<Loading />}>
                    <CaixaHistory />
                  </Suspense>
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/caixa/historico/:caixaId"
              element={
                <PrivateRoute>
                  <Suspense fallback={<Loading />}>
                    <CaixaById />
                  </Suspense>
                </PrivateRoute>
              }
            />
            {isFeatureEnabled('menuImport') && (
            <Route
              exact
              path="/importacao-cardapio"
              element={
                <PrivateRoute>
                  <ImportaCardapio />
                </PrivateRoute>
              }
            />
            )}
            <Route
              exact
              path="/cardapio/:nomeEmpresaForUrl/:idEmpresa"
              element={<Cardapio />}
            />
            <Route
              exact
              path="/cardapio-salao/:nomeEmpresaForUrl/:idEmpresa"
              element={<CardapioSalao />}
            />
            <Route
              exact
              path="/cardapio/:nomeEmpresaForUrl/:idEmpresa/detalhes/:objIdProduto"
              element={<DetalheProduto />}
            />
            <Route
              exact
              path="/cardapio-salao/:nomeEmpresaForUrl/:idEmpresa/detalhes-salao/:objIdProduto"
              element={<DetalheProdutoSalao />}
            />
            <Route
              exact
              path="/cardapio/:nomeEmpresaForUrl/:idEmpresa/carrinho"
              element={<Carrinho />}
            />
            <Route
              exact
              path="/cardapio/:nomeEmpresaForUrl/:idEmpresa/meus-pedidos"
              element={<MeusPedidos />}
            />
            <Route
              exact
              path="/cardapio/:nomeEmpresaForUrl/:idEmpresa/cadastrar-endereco"
              element={<AddEndereco />}
            />
            <Route
              exact
              path="/cardapio/:nomeEmpresaForUrl/:idEmpresa/finalizar-pedido"
              element={<FinalizarPedido />}
            />
            <Route
              exact
              path="/cardapio/:nomeEmpresaForUrl/:idEmpresa/info-loja"
              element={<InfoLoja />}
            />
            {/* Rotas SEO-friendly com slug /c/:slug */}
            <Route exact path="/c/:slug" element={<Cardapio />} />
            <Route exact path="/c/:slug/detalhes/:objIdProduto" element={<DetalheProduto />} />
            <Route exact path="/c/:slug/carrinho" element={<Carrinho />} />
            <Route exact path="/c/:slug/meus-pedidos" element={<MeusPedidos />} />
            <Route exact path="/c/:slug/cadastrar-endereco" element={<AddEndereco />} />
            <Route exact path="/c/:slug/finalizar-pedido" element={<FinalizarPedido />} />
            <Route exact path="/c/:slug/info-loja" element={<InfoLoja />} />
            <Route
              exact
              path="/cardapio-salao/:nomeEmpresaForUrl/:idEmpresa/info-loja-salao"
              element={<InfoLojaSalao />}
            />
            <Route exact path="/recuperar-senha" element={<RecuperarSenha />} />
            <Route
              exact
              path="/redefinir-senha/:token"
              element={<RedefinirSenha />}
            />{" "}
            {/* Após configurar o serviço de e-mail definir rota Privada */}
          </Routes>
          </SidebarProvider>
        </EmpresaProvider>
      </AuthProvider>
    </Router>
  );
};

export default AppRoutes;
